import { render, staticRenderFns } from "./ListScannedCoupons.vue?vue&type=template&id=554c12bf&scoped=true&"
import script from "./ListScannedCoupons.vue?vue&type=script&lang=js&"
export * from "./ListScannedCoupons.vue?vue&type=script&lang=js&"
import style0 from "./ListScannedCoupons.vue?vue&type=style&index=0&id=554c12bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c12bf",
  null
  
)

export default component.exports